import { Control, ControlCodes, getControlName } from "@theprelude/core";
import { z } from "zod";
import { IntegrationForm } from "../integration-form";

const controlCode = ControlCodes.JAMF;
const controlName = getControlName(controlCode);

export const JamfIntegrationForm = ({ instance }: { instance?: Control }) => (
  <IntegrationForm
    control={controlCode}
    instanceId={instance?.instance_id}
    instanceName={instance?.name ?? undefined}
    description={`Connect to ${controlName}, and get a full view of your Apple device estate.`}
    fields={{
      baseUrl: {
        label: "Base URL",
        type: "url",
        defaultValue: instance?.api,
        placeholder: "Enter your Base URL",
        required: true,
        validator: z.string().url(),
      },
      clientId: {
        label: "API Client ID",
        defaultValue: instance?.username,
        placeholder: "Enter your API Client ID",
        required: true,
        validator: z.string().min(1),
      },
      clientSecret: {
        label: "API Client Secret",
        type: "password",
        placeholder: "Enter your API Client Secret",
        required: true,
        validator: z.string().min(1),
      },
    }}
    transformParams={({ baseUrl, clientId, clientSecret }) => ({
      api: baseUrl,
      user: clientId,
      secret: clientSecret,
    })}
  />
);
